/* eslint-disable */

import { createContext, useState, useContext } from 'react';

const AppContext = createContext({} as any);

export const AppContextProvider = ({ children }: any) => {
  const [userNotifications, setUserNotifications] = useState([]);
  const [count, setCount] = useState(0);

  const handleUserNotifications = async (newNotification: any) => {
    // @ts-ignore
    setUserNotifications([newNotification, ...prev]);
    setCount(count + 1);
  };
  return (
    <AppContext.Provider
      value={{
        userNotifications,
        handleUserNotifications,
        count,
        setCount,
        setUserNotifications,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
